<template>

  <section class="py-10 bg-lifeboost-yellow-light lg:py-20" id="the-products">

    <SectionOverlaySubscriptionOverlay v-if="subscriptionOverlay"/>

      <div class="px-2 mx-auto max-w-screen-2xl lg:md:px-4" :class="{'blur pointer-events-none': subscriptionOverlay}">

          <div class="mx-auto">
              <h1 class="text-xl font-bold text-center text-[#3B3B3B] font-ww-bold sm:text-xl md:text-2xl xl:text-28">
                  {{ title }}
              </h1>
              <div class="grid grid-cols-12 mt-3 lg:mt-6" v-if="state.items[state.active.items]">
                  <div class="col-span-12 px-2 md:px-4 lg:col-span-5 lg:px-0 lg:mt-20">
                      <h2 class="Lifeboost™ text-center text-xl font-ww-medium text-[#3B3B3B]">
                          {{ brandName }}
                      </h2>
                      <h3 class="lg:text-4xl text-3xl text-center my-4 font-ww-medium text-[#3B3B3B]">
                          {{ state.items[state.active.items]?.SubName }}
                      </h3>
                      <div class="flex justify-center items-center my-2">
                          <nuxt-img sizes="xs:330px sm:440px md:760px lg:1024px xl:1200x 2xl:1400px" loading="lazy"
                              format="webp" width="120" height="24" :src="starsImageSrc"
                              :alt="starsImageAlt" class="w-24 lg:w-30" />
                          <span class="ml-2 text-[#3B3B3B] font-ww-regular text-base">

                              <strong>{{ currentRating?.avg_rating }}/5</strong>  from <strong>{{ currentRating?.reviews_count }}</strong> reviews
                           
                          </span>
                      </div>

                      <div class="flex gap-x-2 justify-center items-center">
                          <div class="md:text-2xl text-xl font-bold font-ww-medium text-[#3B3B3B]">
                              ${{ helpers.calculatePriceTimesPack(FilteredPacks[state.active.packs].Price, FilteredPacks[state.active.packs].PackSize) }}

                          </div>

                          <span class="text-[#3B3B3B] line-through text-base pt-1">
                              ${{ helpers.calculatePriceTimesPack(FilteredPacks[state.active.packs].SaleRibbon, FilteredPacks[state.active.packs].PackSize) }}
                          </span>
                      </div>

                      <nuxt-img sizes="xs:300px sm:400px md:440px lg:400px xl:400px 2xl:400px" loading="lazy"
                          format="webp" width="400" height="400" :src="FilteredPacks[state.active.packs].Image.url" :alt="productImageAlt"
                          class="mx-auto" />




                  </div>
                  <div class="col-span-12 lg:col-span-7">
                      <div class="w-full sm:px-2 lg:pt-6 md:px-5" id="first-class-swatch">
                          <div class="mx-auto max-w-2xl counter-reset md:px-5 parent-element xl:max-w-3xl">
                              <div class="counter-increment" v-if="Object.keys(state.items).length > 1">
                                  <div
                                      class="flex-wrap py-3 pt-4 pl-16 mb-2 text-xl opacity-75 sm:pl-16 lg:pl-20 lg:text-2xl md:flex font-ww-medium lg:pt-3">
                                      {{ coffeeTypeQuestion }}</div>
                                  <div
                                      class="grid grid-cols-2 gap-2 pl-16 sm-max:gap-x-4 lg:pl-20 sm:pl-16 sm:grid-cols-2 sm:gap-6 sm:max-w-full"
                                      role="radiogroup"
                                      :aria-label="coffeeTypeQuestion">
                                      <!--[-->

                                      <div v-for="(product, index) in state.items"
                                      :key="index"
                                      @click="setProduct(index)"
                                      @keydown.enter.prevent="setProduct(index)"
                                      @keydown.space.prevent="setProduct(index)"
                                      @keydown.right.prevent="moveProductRadio(1)"
                                      @keydown.down.prevent="moveProductRadio(1)"
                                      @keydown.left.prevent="moveProductRadio(-1)"
                                      @keydown.up.prevent="moveProductRadio(-1)"
                                      role="radio"
                                      :aria-checked="state.active.items == index"
                                      :tabindex="state.active.items == index ? 0 : -1"
                                      :class="state.active.items == index ? 'border-[#3D827B] bg-[#E1EAF4] border-2' : 'bg-white border-2 border-white'"
                                          class="flex relative justify-center items-center px-2 py-3 font-medium rounded-lg duration-300 ease-out cursor-pointer md:py-4 md:px-4 hover:scale-110">
                                          
                                          <ElementsCheckmark v-if="state.active.items == index"/>
                                          <p class="text-center opacity-75 font-ww-light">{{ product.Name }}</p>
                                      </div>


                                  </div>
                              </div>
                              <div class="counter-increment" v-if="Object.keys(state.variants).length > 1">
                                  <div
                                      class="flex-wrap py-3 pt-4 pl-16 mb-2 text-xl opacity-75 sm:pl-16 lg:pl-20 lg:text-2xl md:flex font-ww-medium lg:pt-3">
                                      {{ coffeeFormQuestion }}</div>
                                  <div
                                      class="grid grid-cols-2 gap-x-4 gap-y-4 pl-16 lg:pl-20 sm:pl-16 sm:grid-cols-3 sm:gap-6 sm:max-w-full"
                                      role="radiogroup"
                                      :aria-label="coffeeFormQuestion">
                                      <!--[-->
                                      <div v-for="(variant, index) in state.variants" @click="setType(index)"
                                          @keydown.enter.prevent="setType(index)"
                                          @keydown.space.prevent="setType(index)"
                                          @keydown.right.prevent="moveVariantRadio(1)"
                                          @keydown.down.prevent="moveVariantRadio(1)"
                                          @keydown.left.prevent="moveVariantRadio(-1)"
                                          @keydown.up.prevent="moveVariantRadio(-1)"
                                          role="radio"
                                          :aria-checked="state.active.variants == index"
                                          :tabindex="state.active.variants == index ? 0 : -1" :key="index"
                                          :class="state.active.variants == index ? 'border-[#3D827B] bg-[#E1EAF4] border-2' : 'bg-white border-2 border-white'"
                                          class="relative p-4 px-4 py-3 font-medium rounded-lg duration-300 ease-out cursor-pointer md:px-4 md:py-4 hover:scale-110">
                                          <ElementsCheckmark v-if="state.active.variants == index"/>

                                          <p class="text-center opacity-75 font-ww-light">{{  variant.Name }}</p>
                                      </div>
                                  </div>
                              </div>

                              <div class="counter-increment" v-if="Object.keys(FilteredPacks).length > 1">
                                  <div
                                      class="flex-wrap py-3 pt-4 pl-16 mb-2 text-xl opacity-75 sm:pl-16 lg:pl-20 lg:text-2xl md:flex font-ww-medium lg:pt-3">
                                      {{ quantityQuestion }}</div>
                                  <div
                                      class="grid grid-cols-2 gap-2 gap-y-4 pl-16 md:gap-4 lg:pl-20 sm-max:gap-x-4 sm:pl-16 sm:grid-cols-3 lg:gap-4 xl:gap-6 sm:max-w-full"
                                      role="radiogroup"
                                      :aria-label="quantityQuestion">

                                      <div v-for="(pack, index) in FilteredPacks" @click="setPack(index)"
                                      @keydown.enter.prevent="setPack(index)"
                                      @keydown.space.prevent="setPack(index)"
                                      @keydown.right.prevent="movePackRadio(1)"
                                      @keydown.down.prevent="movePackRadio(1)"
                                      @keydown.left.prevent="movePackRadio(-1)"
                                      @keydown.up.prevent="movePackRadio(-1)"
                                      role="radio"
                                      :aria-checked="state.active.packs == index"
                                      :tabindex="state.active.packs == index ? 0 : -1"
                                      :class="state.active.packs == index ? 'border-[#3D827B] bg-[#E1EAF4] border-2' : 'bg-white border-2 border-white'"
                                          class="relative font-medium rounded-lg duration-300 ease-out cursor-pointer hover:scale-110">
                                          <ElementsCheckmark v-if="state.active.packs == index" />

                                        <div class="flex flex-col px-2 pt-3 pb-3 lg:px-3.5 md:px-2 md:pb-4 md:pt-7">
                                          <div class="h-full text-lg leading-5 text-center xl:text-xl font-ww-light">
                                              {{ pack.Name }}
                                          </div>

                                          <div class="xl:text-40 lg:text-3xl font-ww-medium text-[#3B3B3B] text-center sm:mt-3 mt-2 text-3xl pb-2">
                                              {{ pack.Price }}
                                          </div>

                                          <p v-if="pack.Offer" class="text-[#3B3B3B] text-base text-center font-ww-light"
                                          :class="/\d/.test(pack.Offer) && 'line-through'">
                                             {{ pack.Offer }}</p>
                                             <div class="text-[#3B3B3B] text-sm text-center font-ww-light pt-2 leading-4">
                                              {{ saveText }} {{ pack.Discount }} {{ offRetailText }}
                                             </div>
                                        </div>

                                             <div class="px-1 py-1 w-full text-xs leading-3 text-center text-white rounded-b-md border-2 border-lifeboost-gray-black100 bg-lifeboost-gray-black100 font-ww-light" v-if="index === Object.keys(FilteredPacks).length - 1">
                                              {{ ecoFriendlyText }}
                                             </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="counter-increment after:hidden">
                                  <div
                                      class="flex-wrap py-3 pt-4 pl-16 mb-2 text-xl opacity-75 sm:pl-16 lg:pl-20 lg:text-2xl md:flex font-ww-medium lg:pt-3">
                                      {{ shippingQuestion }}</div>
                                  <div class="grid gap-2 xl:grid-cols-7 grid-cols-4 md:grid-cols-4 lg:pl-20 sm:pl-16 pl-16 sm:gap-2 sm:max-w-full !gap-y-6"
                                      role="radiogroup"
                                      :aria-label="shippingQuestion">
                                      <!--[-->
                                      <div v-for="selling_plan, index in filteredSellingPlans"
                                           role="radio"
                                           :aria-checked="currentFilteredIndex == index" :tabindex="currentFilteredIndex == index ? 0 : -1" :key="index"
                                           @click="setFilteredSellingPlan(index)"
                                           @keydown.enter.prevent="setFilteredSellingPlan(index)"
                                           @keydown.space.prevent="setFilteredSellingPlan(index)"
                                           @keydown.right.prevent="movePlanRadio(1)"
                                           @keydown.down.prevent="movePlanRadio(1)"
                                           @keydown.left.prevent="movePlanRadio(-1)"
                                           @keydown.up.prevent="movePlanRadio(-1)"
                                           :class="currentFilteredIndex == index ? 'border-[#3D827B] bg-[#E1EAF4] border-2' : 'bg-white border-2 border-white'"
                                          class="relative px-2 py-2 font-medium rounded-lg duration-300 ease-out cursor-pointer md:px-4 hover:scale-110">
                                          <ElementsCheckmark v-if="currentFilteredIndex == index" />
                                          <div class="pt-1 text-2xl text-center font-ww-light">
                                              {{/\d/.test(selling_plan.sellingPlan.name.split(" ")[0]) ? selling_plan.sellingPlan.name.split(" ")[0] : selling_plan.sellingPlan.name.replace(/[^\d]/g, '') ? selling_plan.sellingPlan.name.replace(/[^\d]/g, '') : "1"  }}
                                          </div>
                                          <p class="text-center opacity-75 font-ww-light"> {{ weekText }} </p>
                                      </div>
                                  </div>
                              </div>


                          </div>
                          <div class="pt-6 mx-auto max-w-2xl text-center md:px-5 lg:pl-32 lg:mx-0 lg:text-left"><button @click="addToCart"
                                  class="relative py-3 w-full text-lg uppercase whitespace-nowrap cursor-pointer btn-red md:w-8/12 xl:w-10/12 font-ww-medium"
                                  style=""> {{ buttonText }} </button>
                          </div>

                      <div class="mx-auto max-w-2xl lg:max-w-full lg:pl-12 sm-max:text-center lg:mx-0">
                          <div class="font-ww-bold text-[#3B3B3B] text-lg mt-6 md:mt-10">
                              {{ planIncludesTitle }}
                          </div>

                          <div class="flex flex-wrap gap-x-4 px-4 mt-4 lg:gap-x-12 md:px-0">
                              <template v-if="planItems && planItems.length > 0">
                                  <div class="text-base text-left font-ww-light xs-max:w-full" v-if="planItems.length >= 2">
                                      {{ planItems[0].text }}
                                      <br v-if="planItems.length >= 2">
                                      {{ planItems.length >= 2 ? planItems[1].text : '' }}
                                  </div>

                                  <div class="text-base text-left font-ww-light xs-max:w-full" v-if="planItems.length >= 3">
                                      {{ planItems.length >= 3 ? planItems[2].text : '' }}
                                      <br v-if="planItems.length >= 4">
                                      {{ planItems.length >= 4 ? planItems[3].text : '' }}
                                  </div>

                                  <div class="text-base text-left font-ww-light xs-max:w-full" v-if="planItems.length >= 5">
                                      {{ planItems.length >= 5 ? planItems[4].text : '' }}
                                  </div>
                              </template>
                          </div>
                      </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>
  </section>

</template>

<script setup>
// Props for dynamic content
const props = defineProps({
subscriptionOverlay: {
  type: Boolean,
  default: false
},
title: {
  type: String,
  default: 'Choose Your Protection Plan:',
},
brandName: {
  type: String,
  default: 'Lifeboost™',
},
starsImageSrc: {
  type: String,
  default: '/assets/images/stars-swatches.png',
},
starsImageAlt: {
  type: String,
  default: 'stars',
},
productImageAlt: {
  type: String,
  default: 'Product Image',
},
coffeeTypeQuestion: {
  type: String,
  default: 'Caffeinated or decaffeinated ?',
},
coffeeFormQuestion: {
  type: String,
  default: 'Beans, ground or pods ?',
},
quantityQuestion: {
  type: String,
  default: 'How many bags would you like ?',
},
shippingQuestion: {
  type: String,
  default: 'How often should we ship ?',
},
saveText: {
  type: String,
  default: 'Save',
},
offRetailText: {
  type: String,
  default: 'off Retail Price',
},
ecoFriendlyText: {
  type: String,
  default: 'Most Environmentally Friendly',
},
weekText: {
  type: String,
  default: 'Week',
},
buttonText: {
  type: String,
  default: 'Lock In Your Price NOW',
},
planIncludesTitle: {
  type: String,
  default: 'Each Plan Includes:',
},
planItems: {
  type: Array,
  default: () => [
    { text: '✓ Price Protection for 12 Months' },
    { text: '✓ Digital Punch Card (8th Order Free)' },
    { text: '✓ Flexible Delivery' },
    { text: '✓ Premium Shipping' },
    { text: '✓ Cancel Anytime' }
  ],
},
page: {
  type: String,
  default: 'inflationshield',
},
});

defineBuilderComponent({
  friendlyName: 'SwatchesSubscription',
  inputs: [
    {
      name: 'title',
      type: 'richText',
      friendlyName: 'Section Title',
      defaultValue: 'Choose Your Protection Plan:',
    },
    {
      name: 'brandName',
      type: 'text',
      friendlyName: 'Brand Name',
      defaultValue: 'Lifeboost™',
    },
    {
      name: 'starsImageSrc',
      type: 'file',
      friendlyName: 'Stars Image Source',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/stars-swatches.png',
    },
    {
      name: 'starsImageAlt',
      type: 'text',
      friendlyName: 'Stars Image Alt Text',
      defaultValue: 'stars',
    },
    {
      name: 'productImageAlt',
      type: 'text',
      friendlyName: 'Product Image Alt Text',
      defaultValue: 'Product Image',
    },
    {
      name: 'coffeeTypeQuestion',
      type: 'text',
      friendlyName: 'Coffee Type Question',
      defaultValue: 'Caffeinated or decaffeinated ?',
    },
    {
      name: 'coffeeFormQuestion',
      type: 'text',
      friendlyName: 'Coffee Form Question',
      defaultValue: 'Beans, ground or pods ?',
    },
    {
      name: 'quantityQuestion',
      type: 'text',
      friendlyName: 'Quantity Question',
      defaultValue: 'How many bags would you like ?',
    },
    {
      name: 'shippingQuestion',
      type: 'text',
      friendlyName: 'Shipping Question',
      defaultValue: 'How often should we ship ?',
    },
    {
      name: 'saveText',
      type: 'text',
      friendlyName: 'Save Text',
      defaultValue: 'Save',
    },
    {
      name: 'offRetailText',
      type: 'text',
      friendlyName: 'Off Retail Text',
      defaultValue: 'off Retail Price',
    },
    {
      name: 'ecoFriendlyText',
      type: 'text',
      friendlyName: 'Eco Friendly Text',
      defaultValue: 'Most Environmentally Friendly',
    },
    {
      name: 'weekText',
      type: 'text',
      friendlyName: 'Week Text',
      defaultValue: 'Week',
    },
    {
      name: 'buttonText',
      type: 'text',
      friendlyName: 'Button Text',
      defaultValue: 'Lock In Your Price NOW',
    },
    {
      name: 'planIncludesTitle',
      type: 'text',
      friendlyName: 'Plan Includes Title',
      defaultValue: 'Each Plan Includes:',
    },
    {
      name: 'planItems',
      type: 'list',
      friendlyName: 'Plan Items',
      defaultValue: [
        { text: '✓ Price Protection for 12 Months' },
        { text: '✓ Digital Punch Card (8th Order Free)' },
        { text: '✓ Flexible Delivery' },
        { text: '✓ Premium Shipping' },
        { text: '✓ Cancel Anytime' }
      ],
      subFields: [
        {
          name: 'text',
          type: 'text',
          friendlyName: 'Item Text',
          defaultValue: ''
        }
      ]
    },
    {
      name: 'page',
      type: 'text',
      friendlyName: 'Page Type',
      defaultValue: 'inflationshield',
    },
  ],
});

const { fetchRatingReview } = useReviews()
const currentRating = ref(null)
// Initialize composables
const { 
state, 
products, 
initializePage,
FilteredPacks,
setPack,
setType,
runEngine,
setProduct,
setSellingPlan,
page,
} = useSwatches()

const { 
addToCart, 
handleButtonClick 
} = useSwatchesCart(runEngine, state, page)

const helpers = useProductHelpers()

initializePage(props.page)

// Compute product ID and handle
const productId = computed(() => 
state.items[state.active.items]?.ExtraData?.reviews.id || "6640339419196"
)
const handle = computed(() => 
state.items[state.active.items]?.ExtraData?.reviews.handle || "medium-roast"
)

// Watch for changes in product selection
watch(
[productId, handle],
async ([newProductId, newHandle]) => {
  currentRating.value = await fetchRatingReview(newProductId, newHandle)
},
{ immediate: true }
)

// Filter to show only Recharge plans (not stay.ai)
const filteredSellingPlans = computed(() => {
const sellingPlans = state.variants[state.active.variants]?.variant?.SellingPlans || []

// Filter to only include Recharge plans (those with "Recharge Plan ID" option)
return sellingPlans.filter(selling_plan => {
  return selling_plan.sellingPlan.options?.some(option => 
    option.name == "Recharge Plan ID"
  )
})
})

// Update setSellingPlan to work with filtered plans
const setFilteredSellingPlan = (filteredIndex) => {
const originalSellingPlans = state.variants[state.active.variants]?.variant?.SellingPlans || []
const selectedFilteredPlan = filteredSellingPlans.value[filteredIndex]

// Find the original index of this plan
const originalIndex = originalSellingPlans.findIndex(plan => 
  plan.sellingPlan.id === selectedFilteredPlan.sellingPlan.id
)

if (originalIndex !== -1) {
  setSellingPlan(originalIndex)
}
}

// Get the filtered index of current selection
const currentFilteredIndex = computed(() => {
const currentPlan = state.variants[state.active.variants]?.variant?.SellingPlans?.[state.active.sellingPlan]
if (!currentPlan) return -1

return filteredSellingPlans.value.findIndex(plan => 
  plan.sellingPlan.id === currentPlan.sellingPlan.id
)
})

// Set 3rd element as default when filtered plans are loaded
watch(filteredSellingPlans, (newFilteredPlans) => {
  if (newFilteredPlans.length >= 3) {
    // Always select the 3rd element (index 2)
    setFilteredSellingPlan(2)
  } else if (newFilteredPlans.length >= 2) {
    // If only 2 elements, select the 2nd one
    setFilteredSellingPlan(1)
  } else if (newFilteredPlans.length > 0) {
    // If only one element, select the first one
    setFilteredSellingPlan(0)
  }
}, { immediate: true })


// Keyboard navigation helpers for radiogroups
const moveProductRadio = (delta) => {
  const keys = Object.keys(state.items)
  if (keys.length === 0) return
  const current = Number(state.active.items) || 0
  const next = (current + delta + keys.length) % keys.length
  setProduct(next)
}

const moveVariantRadio = (delta) => {
  const keys = Object.keys(state.variants)
  if (keys.length === 0) return
  const current = Number(state.active.variants) || 0
  const next = (current + delta + keys.length) % keys.length
  setType(next)
}

const movePackRadio = (delta) => {
  const keys = Object.keys(FilteredPacks)
  if (keys.length === 0) return
  const current = Number(state.active.packs) || 0
  const next = (current + delta + keys.length) % keys.length
  setPack(next)
}

const movePlanRadio = (delta) => {
  const list = filteredSellingPlans.value
  if (!list || list.length === 0) return
  const current = Number(currentFilteredIndex.value)
  const idx = isNaN(current) || current < 0 ? 0 : current
  const next = (idx + delta + list.length) % list.length
  setFilteredSellingPlan(next)
}
</script>

<style scoped>
.swiper-pagination-bullet-active {
  background: #ef4444 !important;
}

.swiper-pagination-bullet {
  background: white;
  opacity: 1;
}

/* .counter-reset .counter-increment {
position: relative;
padding-left: 45px;
} */

.parent-element {
  counter-reset: section 0;
  /* Start counting from 1 */
}

.counter-reset .counter-increment:before {
  @apply content-[counter(section)] absolute font-open-sans md:w-[46px] md:h-[46px] sm:w-11 sm:h-11 h-12 w-12 leading-10 text-center text-[#5a3b36] text-2xl rounded-[45px] border-2 border-solid border-[#5a3b36] left-0 top-2.5;
  counter-increment: section;
}



/* label input:checked~.showbg.cath {
--tw-bg-opacity: 1;
background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

label input:checked~.showbg {
--tw-border-opacity: 1;
border-color: rgba(255, 255, 255, var(--tw-border-opacity));
--tw-bg-opacity: 1;
background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
} */

label input:checked~.showcolor-white {
  @apply bg-white text-black
}

/* label input:checked~ .transition-opacity {
@apply opacity-100
} */

.counter-increment {
  position: relative;
  @apply md:pb-8 pb-2 font-ww-light
}

.counter-increment:after {
  @apply content-[""] absolute h-[calc(100%_-_63px)] border-l-[#4B3D2C] border-l-2 border-solid sm:left-[22.5px] left-6 bottom-0 sm:bottom-0;
}

.sale-price-frosted-cookie s {
  @apply mr-2 !font-normal sm:text-xl text-lg
}
</style>

